import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';

import { TagListFromTagHighlights } from '@playbookux/playbook-web-core';
import {
  Container,
  TaskDuration,
} from './styles';

import TranscriptSection from './transcript';

const TranscriptTimeOnTask = (props) => {
  const {
    answer,
    timeOnTask,
    onSubmit,
    onRemoveTagHighlight,
  } = props;

  const [isEditing, setIsEditing] = useState(false);

  const handleStartEditing = useCallback((newValue) => setIsEditing(newValue), [setIsEditing]);

  return (
    <Container
      dataId={isEditing ? '' : answer.id}
      dataEntity="TestSessionAnswer"
    >
      <TranscriptSection
        answer={answer}
        onSubmit={(value) => onSubmit(value, answer.id)}
        onStartEditing={handleStartEditing}
      />

      <TaskDuration>
        Time on task
        {' '}
        {timeOnTask}
      </TaskDuration>

      <TagListFromTagHighlights
        tagHighlights={answer.tagHighlights}
        onRemoveTagHighlight={onRemoveTagHighlight}
      />
    </Container>
  );
};

TranscriptTimeOnTask.propTypes = {
  answer: PropTypes.shape({
    id: PropTypes.string,
    tagHighlights: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  onSubmit: PropTypes.func.isRequired,
  onRemoveTagHighlight: PropTypes.func.isRequired,
  timeOnTask: PropTypes.node.isRequired,
};

export default TranscriptTimeOnTask;
